import { PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import salsaLogo from '../../assets/salsa.png';
import {
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    background: theme.palette.background.default,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 3),
    borderBottom: `1px solid ${theme.palette.divider}`,
    background: theme.palette.background.paper,
  },
  logo: {
    height: 46,
    objectFit: 'contain',
  },
  content: {
    flex: 1,
    overflow: 'auto',
  },
  signOutButton: {
    textTransform: 'none',
  },
  /* 1. Target the sidebar column by its grid size (lg-2) */
  '& [class*="MuiGrid-grid-lg-2"]': {
    display: 'none !important',
  },

  /* 2. Force the template list (lg-10) to fill the whole screen */
  '& [class*="MuiGrid-grid-lg-10"]': {
    flexBasis: '100% !important',
    maxWidth: '100% !important',
  },

  /* 3. Safety net: target the specific Scaffolder/Catalog pickers by their stable prefix */
  '& [class*="ScaffolderReactTemplateCategoryPicker"], [class*="CatalogReactUserListPicker"], [class*="CatalogReactEntityOwnerPicker"]': {
    display: 'none !important',
  }
}));

export const GuestLayout = ({ children }: PropsWithChildren<{}>) => {

  const classes = useStyles();
  const identityApi = useApi(identityApiRef);

  const handleSignOut = async () => {
    await identityApi.signOut();
    window.location.reload();
  };

  return (
    <div className={`${classes.root} guest-layout`}>
      <header className={classes.header}>
        <img
          src={salsaLogo}
          alt="Salsa Digital"
          className={classes.logo}
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
            if (target.parentElement) {
              target.parentElement.innerHTML =
                '<span style="color: #B82025; font-weight: 700; font-size: 20px;">SALSA</span>';
            }
          }}
        />
        <Button
          className={classes.signOutButton}
          startIcon={<ExitToAppIcon />}
          onClick={handleSignOut}
          color="primary"
          variant="outlined"
          size="small"
        >
          Sign in
        </Button>
      </header>
      <main className={classes.content}>{children}</main>
    </div>
  );
};
